<template>
  <div class="box">
    <div class="top">
      <img
        src="@/assets/img/common/rightsCourse/bg.png"
        alt=""
        class="bg"
      >
      <div class="content">
        <img
          src="@/assets/img/common/rightsCourse/title.png"
          alt=""
          class="title"
        >
        <div class="tip">
          2门课程/1年有效期
        </div>
      </div>
    </div>
    <div class="main">
      <div class="codeBox">
        <div class="inputBox">
          <input
            v-model="gserialno"
            placeholder="请输入权益兑换码，兑换后立即生效"
            type="text"
            name=""
            id=""
          >
        </div>
        <div class="tip">
          *课程权益兑换成功，进入每门课程详情页可观看学习
        </div>
      </div>
      <div class="courseList">
        <div class="title">选择课程</div>
        <ul>
          <li
            v-for="(item,index) in course"
            :key="index"
            @click="chooseCoures=index"
          >
            <img
              class="radio"
              :src="require(`@/assets/img/common/rightsCourse/radio${chooseCoures==index?'s':''}.png`)"
              alt=""
            >
            <div class="course">
              <img
                :src="item.image"
                alt=""
              >
              <div class="info">
                <div class="nameBox">
                  <div class="name ellipsis">{{item.name}}</div>
                  <div class="teacher ellipsis">{{item.teacher+' · '+item.title}}</div>
                </div>
                <div class="count">
                  共{{item.count}}讲 / 原价¥{{item.price}}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <div
        :class="['btn',gserialno?'active':''] "
        @click="submit"
      >确认兑换</div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "爱艺术+权益课程",
    };
  },
  data() {
    return {
      gserialno: "",
      chooseCoures: 0,
      course: [
        {
          name: "山水画创作课程",
          teacher: "王保安",
          title: "西美继续教育学院院长",
          count: 42,
          price: '348.00',
          image: "https://picture.iartschool.com/20210207/807969405592928256.jpg",
          id:'707909424508829696'
        },
        {
          name: "和声基础课程",
          teacher: "赵波",
          title: "上音附中讲师",
          count: 22,
          price: '228.00',
          image: "https://picture.iartschool.com/20210308/818534018046754816.jpg",
          id:'778'
        },
      ],
    };
  },
  mounted () {
    this.gserialno=this.util.vueGetQueryString("gserialno")||'';
  },
  methods: {
    submit() {
      if (!this.gserialno) {
        return;
      }
      let obj = {
        secretkey:this.util.vueGetQueryString("secretkey"),
        gserialno: this.gserialno,
        courseid:this.course[this.chooseCoures].id ,
        packcouponid: "1415706705522622464",
      };
      this.util.showLoading();
      this.$post("/iart-api-crm/api/crm/cooperate/exchangeCourse", obj).then(
        (res) => {
          this.util.hideLoading();
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              this.util.toast({
                msg: "兑换成功",
              });
            } else {
              this.util.toast({
                msg: res.data.rtnmsg,
              });
            }
          } else {
            this.util.toast({
              msg: res.message,
            });
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  min-height: 100vh;
  background: #fff;
  .top {
    position: relative;
    z-index: 1;
    .bg {
      width: 100%;
      height: auto;
    }
    .content {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        height: 72px;
        width: auto;
      }
      .tip {
        margin-top: 10px;
        font-size: 12px;
        line-height: 22px;
        color: #35363c;
      }
    }
  }
  .main {
    margin: -26px 32px 0;
    position: relative;
    z-index: 11;
    background: #fff;
    .codeBox {
      text-align: center;
      .inputBox {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        border: 1px solid rgba(151, 151, 151, 0.3);
        padding: 14px;
        input {
          width: 100%;
          font-size: 16px;
          line-height: 24px;
          color: #35363c;
          font-weight: bold;
          &::placeholder {
            color: #aeafb1;
            text-align: center;
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
      .tip {
        text-align: center;
        margin-top: 8px;
        color: rgba(0, 0, 0, 0.4);
        font-size: 12px;
        line-height: 18px;
      }
    }
    .courseList {
      margin-top: 32px;
      .title {
        color: rgba(53, 54, 60, 1);
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
      }
      ul {
        li {
          padding: 12px 0;
          display: flex;
          flex-direction: row;
          align-items: center;
          .radio {
            display: inline-block;
            width: 32px;
            height: 32px;
          }
          .course {
            flex: 1;
            overflow: hidden;
            margin-left: 1px;
            display: flex;
            flex-direction: row;
            img {
              width: 134px;
              height: 82px;
              object-fit: cover;
            }
          }
          .info {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 12px;
            font-size: 11px;
            line-height: 16px;
            .name {
              color: rgba(53, 54, 60, 1);
              font-weight: bold;
              font-size: 14px;
              line-height: 20px;
            }
            .teacher {
              margin-top: 4px;
              color: rgba(45, 45, 45, 1);
            }
            .count {
              color: rgba(45, 45, 45, 0.6);
            }
          }
        }
      }
    }
  }
  .footer {
    padding: 40px 32px;
    .btn {
      color: rgba(255, 255, 255, 1);
      font-size: 14px;
      line-height: 20px;
      padding: 13px 0;
      text-align: center;
      background: rgba(206, 206, 206, 1);
      border-radius: 3px;
      &.active {
        background: rgba(201, 55, 61, 1);
      }
    }
  }
}
</style>